<template>
	<div class="buttonGroups" :class="{'center': center}" :style="{ padding, margin }">
		<custom-btn v-if="isBtnDelete" text="DELETE" custom-class="btnDelete" @updateEvent="onDelete" margin="0"></custom-btn>
		<custom-btn
				margin="0"
				v-if="!isCancelHide"
				:text="cancelText"
				custom-class="cancel"
				@updateEvent="onClose"
				:isExtended="isExtended"
		></custom-btn>
		<custom-btn
				margin="0"
				v-if="isSave"
				:is-preloader="preloader"
				:is-disabled="preloader || isBtnSafe || isDisabled"
				:text="applyText"
				:isExtended="isExtended"
				:width="width"
				:height="height"
				custom-class="apply"
				@updateEvent="onSave"
		></custom-btn>
	</div>
</template>

<script>
import CustomBtn from "@/shared/CustomBtn/CustomBtn.vue";

export default {
	name: "ButtonGroups",
	components: {
		CustomBtn
	},
	props: {
		padding: {
			type: String,
			default: '0'
		},
		margin: {
			type: String,
			default: '0'
		},
		width: String,
		height: String,
		isSave: {
			type: Boolean,
			default: () => true
		},
		center: Boolean,
		preloader: Boolean,
		isExtended: Boolean,
		isInvalid: Boolean,
		isBtnDelete: Boolean,
		isBtnSafe: Boolean,
		isDisabled: Boolean,
		applyText: {
			type: String,
			default: () => "SAVE"
		},
		cancelText: {
			type: String,
			default: () => "CANCEL"
		},
		isCancelHide: Boolean
	},
	methods: {
		onClose() {
			this.$emit('updateBtnClose');
		},
		onSave() {
			this.$emit('updateSave');
		},
		onDelete() {
			this.$emit('updateDelete');
		}
	}
};
</script>

<style scoped lang="scss">
.buttonGroups {
	display: flex;
	justify-content: flex-end;
	gap: 10px;

	&.center {
		justify-content: center;
	}
	&.between {
		justify-content: space-between;
	}
}
</style>
